module.exports = __webpack_public_path__ + "static/etkinkli2022-e19ce3690b48437f53f2299721612a95.jpg";